import React from 'react';

const BigBlack = ({ label, onClick }) => {
    return (
        <div
            onClick={onClick}
            className='font-favela-bold mx-auto flex justify-center uppercase items-center bg-black text-white w-10/12 md:w-8/12 min-h-[60px] rounded-full'
        >
            {label}
        </div>
    );
};

export default BigBlack;
